<template>
<span class='m-0 p-0'>
  <b-input-group>
    <slot name=prepend></slot>
    <b-form-textarea v-if=textarea :type=type :disabled=disabled :required=required v-model=value @input=onInput />
    <b-form-select v-else-if=select :disabled=disabled :required=required v-model=value @input=onInput :options=selectOptions />
    <b-form-checkbox v-else-if=checkbox :disabled=disabled :required=required v-model=value @input=onInput><slot name=default></slot></b-form-checkbox>
    <b-form-input v-else :type=type :step=step :disabled=disabled :required=required v-model=value @input=onInput />
    <slot name=append></slot>
  </b-input-group>
</span>
</template>

<script>
import orderMerge from '../../services/orderMerge'

export default {
  data() {
    return {
      default: undefined,
      value: undefined,
    };
  },
  props: {
    dict: { type: Object, required: true },
    type: { type: String, required: false, default: 'text' },
    step: { type: Number, required: false, default: 1 },
    textarea: { type: Boolean, required: false, default: false },
    select: { type: Boolean, required: false, default: false },
    selectOptions: { type: Array, required: this.select, default: () => [] },
    checkbox: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: true },
    required: { type: Boolean, required: false, default: false },
  },
  mounted() {
    this.default = orderMerge.mergeField(this.dict)
    this.value = this.default
    if (this.dict) {
      this.dict['edited'] = this.value
    }
  },
  methods: {
    onInput(e) {
      if (typeof(e) === 'undefined') return;
      this.dict['edited'] = e
      this.$emit('input', e);
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/utility/InputMerger.vue